export default "__VITE_ASSET__Blu9JOVG__"